if (document.querySelector('.cookie-notice .close-btn')) {
    const cookieClose = document.querySelector('.cookie-notice .close-btn');

    cookieClose.addEventListener('click', () => {
        closeCookieNotice();
        console.log('close');
    });
}

if (document.querySelector('.cookie-notice .accept')) {
    const cookieAccept = document.querySelector('.cookie-notice .accept');

    cookieAccept.addEventListener('click', () => {
        acceptCookies()
        // console.log('accept');
    });
}

export const closeCookieNotice = () => {
    const notice = document.getElementById('cookieNotice');

    notice.classList.add('accepted');

    setTimeout(() => {
        notice.style.display = 'none';
    }, 500);

}

export const displayCookieNotice = () => {
    const notice = document.getElementById('cookieNotice');

    notice.style.display = 'block';
}

export const acceptCookies = () => {
    // Set for 365 days
    const d = new Date();
    d.setTime(d.getTime() + (365*24*60*60*1000));
    let expires = "expires=" + d.toUTCString();

    document.cookie = 'accepted=true;' + expires;
    localStorage.setItem("accepted", "true");

    closeCookieNotice();
}

export const getCookie = (cname) => {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export const checkCookieStatus = () => {
    let accepted = getCookie("accepted");
    let acceptedLocal = localStorage.getItem("accepted");

    // console.log('Cookie: '+accepted);
    // console.log('cookie check ' + acceptedLocal);
    //
    // if (accepted === '') {
    //     displayCookieNotice();
    // }

    if (acceptedLocal !== 'true') {
        displayCookieNotice();
    }
}


document.addEventListener("DOMContentLoaded", () => {
    checkCookieStatus();
    // console.log('cookies');
});
